export function number(input) {
  return input ? input.toLocaleString("es-AR") : "";
}

export function currency(input) {
  return input
    ? input.toLocaleString("es-AR", {
        style: "currency",
        currency: "ARS",
        minimumFractionDigits: 0,
      })
    : "";
}

export function getDiscountAmount(vehicle, promotion) {
  if (!promotion) {
    return 0;
  }

  if (promotion.percentage_discount) {
    return vehicle.price * (promotion.percentage_discount / 100);
  }

  return promotion.money_discount;
}

export function slugify(url) {
  return url.toLowerCase().replace(/[\s]/g, "-").trim();
}
